
import React from "react";
import {Controller} from "react-hook-form";
import {Rating} from "react-simple-star-rating";

const FormRating = ( { validate, control, name, readOnly, options }) =>
{
    return <Controller
        control={control}
        name={name}
        rules={{ required: false, validate: validate}}
        render={({ field: { onChange, value, name, ref },
                     fieldState: { invalid, isTouched, isDirty, error },
                     formState,
                 }) =>
            <Rating name={name} onClick={onChange} fillColorArray={['#f67236', '#f19745', '#f3e63c', '#bee455', '#a5ed3d']} initialValue={value} size={25} allowHover={false}
                    iconsCount={5}/>
        } />
}

export default FormRating ;
